export default __webpack_public_path__ + "static/media/bg_tutorial.5a6b6105.png";